import { Link } from "react-router-dom";
import { categoryEntries } from "@/mocks/site";
import { countFilmsByType } from "@/lib/content";
import type { FilmType } from "@/mocks/shortFilms";

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
      {categoryEntries.map((entry) => (
        <Link
          key={entry.type}
          to={`/category/shortfilms?type=${encodeURIComponent(entry.type)}`}
          className="group relative h-[148px] md:h-[168px] rounded-lg overflow-hidden bg-foreground-950 cursor-pointer"
        >
          <img
            src={entry.image}
            alt={`${entry.title}短片分类`}
            title={`${entry.title}短片 - 小电影`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-3.5">
            <div className="flex items-center gap-2">
              <span className="w-7 h-7 rounded-md bg-background-50/15 backdrop-blur-sm flex items-center justify-center">
                <i className={`${entry.icon} text-sm text-background-50`} />
              </span>
              <span className="text-[15px] font-bold text-background-50">{entry.title}</span>
              <span className="ml-auto text-[11px] font-label text-accent-400">
                {countFilmsByType(entry.type as FilmType)} 部
              </span>
            </div>
            <p className="mt-1.5 text-[11px] leading-5 text-background-300 line-clamp-1">
              {entry.description}
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
}